export const HOME_ROUTE = '/';
export const LOGIN = '/login';
export const SETTINGS = '/settings';
export const HOME_SCREEN = '/home';
export const LOGIN_REDIRECT = '/login-redirect';
export const LOGIN_CALLBACK = '/login/callback';
export const SIGNUP = '/signup';
export const PATIENT_DETAILS = '/patient-details';
export const SUMMARY = '/summary';
export const DISEASE_PRELAVENCE = '/disease-prelavence';
export const DISEASE_PRELAVENCE_BY_CONDITION = '/disease-prelavence/:condition';
export const CHRONIC_PREVALENCE = '/chronic-prelavence';
export const CHRONIC_PREVALENCE_BY_CONDITION = '/chronic-prelavence/:condition';
export const RISING_RISK = '/rising-risk';
export const RISING_RISK_DETAILS = '/rising-risk-details';
export const CARE_QUALITY = '/care-quality';
export const CARE_QUALITY_INTERNAL = '/care-quality-internal';
export const HIGH_COST_CLAIMS = '/high-cost-claims';
export const STOPLOSS_TRIGGERS = '/stoploss-triggers';
export const STOPLOSS_TRIGGERS_INTERNAL = '/stoploss-triggers-internal';
export const REPORT_PLAN = '/report-plan';
export const PLAN_PERFORMANCE = '/plan-performance';
export const CLAIMS_METRICS = '/claims-metrics';
export const ENROLLMENT_METRICS = '/enrollment-metrics';
export const PENDING_CLAIMS = '/pending-claims';
export const REJECTED_CLAIMS = '/rejected-claims';
export const NETWORK_LEAKAGE = '/network-leakage';
export const UTILIZATION_METRICS = '/utilization-metrics';
export const PATIENT_ADMISSION = '/patient-admission';
export const RX_UTILIZATION = '/rx-utilization';
export const PROCEDURE_UTILIZATION = '/procedure-utilization';
export const PROVIDER_UTILIZATION = '/provider-utilization';
export const USER_MANAGEMENT = '/user-management';
export const MEMBER_SUMMARY = '/member-summary';
export const RISK_PATIENT_DETAILS = '/risk-patient-details';
export const EPISODES_OF_CARE = '/episodes-of-care';
export const EPISODES_OF_CARE_SELECTED = '/episodes-of-care-selected';
export const ALL_REPORTS = '/pdf-reports-builder';
export const REPORTS = '/reports';
export const REPORTS_PPT = '/reports-ppt';
export const MED_PHARMA = '/med-pharma';
export const SPECIALITY_DRUGS = '/speciality-drugs';
export const OTHER_PRESCRIPTION = '/other-prescription';
export const ERROR = '/error';
export const RESET_PASSWORD = '/reset-password';
export const CUSTOM_QUERY_BUILDER = '/custom-query-builder';
export const WASTE_CALCULATOR = '/waste-calculator';
export const WASTE_CALCULATOR_DETAILS = '/waste-calculator-details';
export const SPECIFIC_DEDUCTIBLE_CORRIDORS = '/specific-deductible-corridors';
export const KPI_TRACKER = '/kpi-tracker';
export const KPI_TRACKER_INTERNAL = '/kpi-tracker-internal';
export const ONBOARDING = '/onboarding';
export const ONBOARDINGSTATUS = '/onboardingstatus';
export const CONTRACT_RISK_ANALYSIS = '/contract-risk-analysis';
export const CONTRACT_AIQ = '/contract';
export const CONTRACT_AIQ_INTERNAL = '/contract-selected';
export const CONTRACT_AIQ_REPORTS = '/review-report';
export const PLAYBOOK = '/playbook';
export const PROFILE = '/profile';
export const ACCESS_DASHBOARD = '/dashboard';
export const ACCESS_DASHBOARD_INTERNAL = '/dashboard/:category';
export const COMPLIANCE_ASSURANCE = '/compliance-assurance';
export const PLAN_DOCUMENTS = '/plan-documents';
export const PLAN_DOCUMENTS_INTERNAL = '/plan-document-selected';
export const CUSTOM_ANALYSIS = '/custom-analysis';
export const RECOMMENDATIONS = '/recommendations';
export const CLAIM_ANALYSIS = '/claim-analysis';
export const TASK_BOARD = '/task-board';
export const COMPLIANCE_REPORT = '/compliance-report';
export const STOPLOSS_REPORT = '/stoploss-report';
export const PLAYBOOK_INTERNAL_PAGE = '/playbook-internal';
export const PLAYBOOK_DETAILS = '/playbook-details';
export const GAG_CLAUSE_REPORT = '/gag-clause';
export const GAG_CLAUSE_COMPLIANCE = '/gag-clause-compliance/:type?';
export const REGULATORY_COMPLIANCE_REPORT = '/regulatory-compliance';
export const PURCHASING_STANDARDS_REPORT = '/purchasing-standards';
export const COMPENSATION_TRANSPARENCY_REPORT = '/compensation-transparency';
export const CUSTOM_QUERY_INTERNAL = '/custom-query-builder-internal';
export const INTER_CONTRACT_REPORT = '/inter-contract';
export const RISK_PROFILING_BY_CHRONIC = '/risk-profiling-by-chronic';
export const RISK_PROFILING_BY_TRIGGER = '/risk-profiling-by-trigger';
export const RISK_PROFILING_BY_COST = '/risk-profiling-by-cost';
export const RISK_PROFILING_BY_UTILIZATION = '/risk-profiling-by-utilization';
export const GLP_DRUGS = '/glp-drugs';
export const CHRONIC_COHORT = '/chronic-cohort-analysis';
export const HIGH_COST_COHORT = '/high-cost-cohort';
export const MULTIPLE_DRUG_COHORT = '/multiple-drug-cohort';
export const MEMBER_LIST = '/members-list';
export const RISK_PROFILING_BY_DRUGS = '/risk-profiling-by-drugs';
export const CONTRACT_ONBOARDING = '/contract-onboarding';
export const SAVINGS_UTILIZATION = '/savings-utilization';
export const DATA_CATALOGUE = '/data-catalogue';
export const MERGE_DOCUMENTS = '/merge-documents';
export const PATIENT_CASES = '/patient-cases';
export const CARE_NAVIGATOR = '/care-navigator';
export const CARE_NAVIGATOR_PROFILE = '/care-navigator-profile';
export const TICKET_MANAGEMENT = '/ticket-management';
export const DRAFT_AGREEMENTS = '/draft-agreements';
export const DRAFT_SELECTED = '/draft-selected';
export const MA_DUE_DILIGENCE = '/due-diligence';
export const MA_DUE_DILIGENCE_INTERNAL = '/due-diligence-internal';
export const MA_DUE_DILIGENCE_ADD = '/due-diligence-add';
export const DOC_COMPARISON = '/doc-comparison';
export const NEW_DOC_COMPARISON = '/new-doc-comparison';
export const DOC_COMP_INTEGRAL = '/doc_comp_integral';
export const RISK_REGISTER = '/risk-register';
export const EXPERICENCE_SCREEN = '/experience';
export const ALL_INSIGHTS_NOTIFICATION = '/all-insights-notification';
export const CUSTOMIZE_NOTIFICATION = '/customize-notification';
export const FINANCIAL_FORENSICS = '/financial-forensics';
export const SCENARIO_WORKSPACE = '/scenario-workspace';
export const SCENARIO_LIBRARY = '/scenario-library';
export const RECONCILIATION_WORKSPACE = '/reconciliation-workspace';
export const RECONCILIATION_LIBRARY = '/reconciliation-library';
export const DEEP_DIVE = '/deep-dive';
export const TERM_COMPILER = '/term-compiler';
export const NEW_TERM_COMPILER = '/new-term-compiler';
export const TERM_COMPILER_INTERNAL = '/term-compiler-internal';
export const CLAIMS_LIST = '/claims-list';
export const TREND_ANALYSIS = '/trend-analysis';
export const TREND_ANALYSIS_INTERNAL = '/trend-analysis-internal';
export const ANNUAL_RENEWAL_PROCESS = '/annual-renewal-process';
export const RENEWAL_DETAILS = '/annual-renewal-process-details';
export const PLAYBOOK_AND_STANDARD = '/playbook-and-standards';
export const PLAYBOOK_AND_STANDARD_INTERNAL = '/playbook-and-standard-internal';
export const PAYMENT_INTEGRITY = '/payment-integrity';
export const PAYMENT_INTEGRITY_INTERNAL = '/payment-integrity-internal';
export const CMS_BENCHMARK = '/cms-benchmark';
export const CMS_BENCHMARK_INTERNAL = '/cms-benchmark-internal';
export const CHAT = '/chat';
export const COHORT_COMPARISON = '/cohort-comparison';
export const COHORT_COMPARISON_INTERNAL = '/cohort-comparison-internal';
export const PROPOSAL_ANALYZER = '/proposal-analyzer';

// map.set(SUB_ROUTE,MAIN_ROUTE)
export const routeMap = new Map<string, string>();

//Access Dashboard
routeMap.set(ACCESS_DASHBOARD, ACCESS_DASHBOARD);
routeMap.set(DISEASE_PRELAVENCE, ACCESS_DASHBOARD);
routeMap.set(CHRONIC_PREVALENCE, ACCESS_DASHBOARD);
routeMap.set(RISING_RISK, ACCESS_DASHBOARD);
routeMap.set(RISING_RISK_DETAILS, ACCESS_DASHBOARD);
routeMap.set(CARE_QUALITY, ACCESS_DASHBOARD);
routeMap.set(CARE_QUALITY_INTERNAL, ACCESS_DASHBOARD);
routeMap.set(EPISODES_OF_CARE, ACCESS_DASHBOARD);
routeMap.set(EPISODES_OF_CARE_SELECTED, ACCESS_DASHBOARD);
routeMap.set(WASTE_CALCULATOR, ACCESS_DASHBOARD);
routeMap.set(WASTE_CALCULATOR_DETAILS, ACCESS_DASHBOARD);
routeMap.set(HIGH_COST_CLAIMS, ACCESS_DASHBOARD);
routeMap.set(STOPLOSS_REPORT, ACCESS_DASHBOARD);
routeMap.set(REPORT_PLAN, ACCESS_DASHBOARD);
routeMap.set(STOPLOSS_TRIGGERS, ACCESS_DASHBOARD);
routeMap.set(STOPLOSS_TRIGGERS_INTERNAL, ACCESS_DASHBOARD);
routeMap.set(SPECIFIC_DEDUCTIBLE_CORRIDORS, ACCESS_DASHBOARD);
routeMap.set(PLAN_PERFORMANCE, ACCESS_DASHBOARD);
routeMap.set(CLAIMS_METRICS, ACCESS_DASHBOARD);
routeMap.set(ENROLLMENT_METRICS, ACCESS_DASHBOARD);
routeMap.set(NETWORK_LEAKAGE, ACCESS_DASHBOARD);
routeMap.set(REJECTED_CLAIMS, ACCESS_DASHBOARD);
routeMap.set(PENDING_CLAIMS, ACCESS_DASHBOARD);
routeMap.set(PATIENT_ADMISSION, ACCESS_DASHBOARD);
routeMap.set(PROCEDURE_UTILIZATION, ACCESS_DASHBOARD);
routeMap.set(PROVIDER_UTILIZATION, ACCESS_DASHBOARD);
routeMap.set(RX_UTILIZATION, ACCESS_DASHBOARD);
routeMap.set(UTILIZATION_METRICS, ACCESS_DASHBOARD);
routeMap.set(MED_PHARMA, ACCESS_DASHBOARD);
routeMap.set(SPECIALITY_DRUGS, ACCESS_DASHBOARD);
routeMap.set(OTHER_PRESCRIPTION, ACCESS_DASHBOARD);
routeMap.set(PATIENT_DETAILS, ACCESS_DASHBOARD);
routeMap.set(RISK_PATIENT_DETAILS, ACCESS_DASHBOARD);
routeMap.set(RISK_PROFILING_BY_CHRONIC, ACCESS_DASHBOARD);
routeMap.set(RISK_PROFILING_BY_TRIGGER, ACCESS_DASHBOARD);
routeMap.set(RISK_PROFILING_BY_COST, ACCESS_DASHBOARD);
routeMap.set(RISK_PROFILING_BY_UTILIZATION, ACCESS_DASHBOARD);
routeMap.set(GLP_DRUGS, ACCESS_DASHBOARD);
routeMap.set(RISK_PROFILING_BY_DRUGS, ACCESS_DASHBOARD);
routeMap.set(SAVINGS_UTILIZATION, ACCESS_DASHBOARD);
routeMap.set(FINANCIAL_FORENSICS, ACCESS_DASHBOARD);
routeMap.set(SCENARIO_WORKSPACE, ACCESS_DASHBOARD);
routeMap.set(SCENARIO_LIBRARY, ACCESS_DASHBOARD);
routeMap.set(RECONCILIATION_WORKSPACE, ACCESS_DASHBOARD);
routeMap.set(RECONCILIATION_LIBRARY, ACCESS_DASHBOARD);
routeMap.set(DEEP_DIVE, ACCESS_DASHBOARD);
routeMap.set(SUMMARY, ACCESS_DASHBOARD);
routeMap.set(MEMBER_LIST, ACCESS_DASHBOARD);
routeMap.set(CLAIMS_LIST, ACCESS_DASHBOARD);
routeMap.set(TREND_ANALYSIS, ACCESS_DASHBOARD);
routeMap.set(COHORT_COMPARISON, ACCESS_DASHBOARD);
routeMap.set(COHORT_COMPARISON_INTERNAL, ACCESS_DASHBOARD);
routeMap.set(PAYMENT_INTEGRITY, ACCESS_DASHBOARD);
routeMap.set(PAYMENT_INTEGRITY_INTERNAL, ACCESS_DASHBOARD);
routeMap.set(CMS_BENCHMARK, ACCESS_DASHBOARD);
routeMap.set(CMS_BENCHMARK_INTERNAL, ACCESS_DASHBOARD);
routeMap.set(CHAT, CHAT);

//Compliance Assurance
routeMap.set(PLAN_DOCUMENTS, COMPLIANCE_ASSURANCE);
routeMap.set(PLAN_DOCUMENTS_INTERNAL, COMPLIANCE_ASSURANCE);
routeMap.set(CONTRACT_AIQ, COMPLIANCE_ASSURANCE);
routeMap.set(PLAYBOOK, COMPLIANCE_ASSURANCE);
routeMap.set(CONTRACT_AIQ_INTERNAL, COMPLIANCE_ASSURANCE);
routeMap.set(CONTRACT_AIQ_REPORTS, COMPLIANCE_ASSURANCE);
routeMap.set(PLAYBOOK_INTERNAL_PAGE, COMPLIANCE_ASSURANCE);
routeMap.set(PLAYBOOK_DETAILS, COMPLIANCE_ASSURANCE);
routeMap.set(GAG_CLAUSE_COMPLIANCE, COMPLIANCE_ASSURANCE);
routeMap.set(CONTRACT_ONBOARDING, COMPLIANCE_ASSURANCE);
routeMap.set(MERGE_DOCUMENTS, COMPLIANCE_ASSURANCE);
routeMap.set(DRAFT_AGREEMENTS, COMPLIANCE_ASSURANCE);
routeMap.set(DRAFT_SELECTED, COMPLIANCE_ASSURANCE);

routeMap.set(MA_DUE_DILIGENCE, COMPLIANCE_ASSURANCE);
routeMap.set(MA_DUE_DILIGENCE_INTERNAL, COMPLIANCE_ASSURANCE);
routeMap.set(MA_DUE_DILIGENCE_ADD, COMPLIANCE_ASSURANCE);

routeMap.set(TERM_COMPILER, COMPLIANCE_ASSURANCE);
routeMap.set(NEW_TERM_COMPILER, COMPLIANCE_ASSURANCE);
routeMap.set(TERM_COMPILER_INTERNAL, COMPLIANCE_ASSURANCE);

// New Comparison
routeMap.set(DOC_COMPARISON, COMPLIANCE_ASSURANCE);
routeMap.set(NEW_DOC_COMPARISON, COMPLIANCE_ASSURANCE);
routeMap.set(DOC_COMP_INTEGRAL, COMPLIANCE_ASSURANCE);

//Annual Renewal Process
routeMap.set(ANNUAL_RENEWAL_PROCESS, COMPLIANCE_ASSURANCE);
routeMap.set(RENEWAL_DETAILS, COMPLIANCE_ASSURANCE);
routeMap.set(PLAYBOOK_AND_STANDARD, COMPLIANCE_ASSURANCE);
routeMap.set(PLAYBOOK_AND_STANDARD_INTERNAL, COMPLIANCE_ASSURANCE);

// // Experience Screen
// routeMap.set(EXPERICENCE_SCREEN, COMPLIANCE_ASSURANCE);
// routeMap.set(ALL_INSIGHTS_NOTIFICATION, COMPLIANCE_ASSURANCE);
// routeMap.set(CUSTOMIZE_NOTIFICATION, COMPLIANCE_ASSURANCE);

//Custom Analysis
routeMap.set(KPI_TRACKER, CUSTOM_ANALYSIS);
routeMap.set(KPI_TRACKER_INTERNAL, CUSTOM_ANALYSIS);
routeMap.set(CHRONIC_COHORT, CUSTOM_ANALYSIS);
routeMap.set(HIGH_COST_COHORT, CUSTOM_ANALYSIS);
routeMap.set(MULTIPLE_DRUG_COHORT, CUSTOM_ANALYSIS);

//Recommendations
routeMap.set(CLAIM_ANALYSIS, RECOMMENDATIONS);
routeMap.set(CONTRACT_RISK_ANALYSIS, RECOMMENDATIONS);

routeMap.set(COMPLIANCE_REPORT, ALL_REPORTS);
routeMap.set(REPORTS, ALL_REPORTS);
routeMap.set(REPORTS_PPT, ALL_REPORTS);

// Proposal Analyzer

routeMap.set(PROPOSAL_ANALYZER, COMPLIANCE_ASSURANCE);
